angular.module("warsApp.directives").directive('charactersRemaining', function () {
    return {
        restrict: 'E',
        scope: {
            property: '=',
            field: '='
        },
        templateUrl: './app/views/directives/charactersRemaining.html',
        controller: ['$scope', function ($scope) {
            $scope.pageFlow = {
                showCharacters: false
            }
            $scope.model = {
                remaining: 0
            }
            $scope.$watch('property', function () {
                var max = $scope.field.maxTextLength;
                if (max == null) {
                    max = 4000;
                }
                if ($scope.property !== undefined && $scope.property !== null) {
                    $scope.pageFlow.showCharacters = true;
                    var remaining = parseInt(max) - $scope.property.length;
                    if (remaining < 0) {
                        $scope.property = $scope.property.substring(0, max);
                    }
                    $scope.model.remaining = parseInt(max) - $scope.property.length;
                } else {
                    $scope.pageFlow.showCharacters = false;
                }
            });
        }]
    }
});